// Inbox Archive (Phase 1C) — viewer routes.
// Sits under Settings → Archived Inboxes. Listing + detail pages are lazy-loaded
// so they only enter the bundle when an admin actually opens them.
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingWrapper from '../SettingsWrapper.vue';

const ArchivedInboxesList = () => import('./Index.vue');
const ArchivedInboxDetail = () => import('./Show.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/archives'),
      component: SettingWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_archives_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_archives_list',
          component: ArchivedInboxesList,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_ARCHIVE,
            permissions: ['administrator', 'archive_view'],
          },
        },
        {
          path: ':inboxId',
          name: 'settings_archives_show',
          component: ArchivedInboxDetail,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_ARCHIVE,
            permissions: ['administrator', 'archive_view'],
          },
        },
      ],
    },
  ],
};
